// removed by extract-text-webpack-plugin
module.exports = {"side":"_3mbdAB3Vem7peOns_OVvny_0","main":"_356RovEACsxRN-HWJQe72L_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59f211ec","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/index.vue
// module id = 3a1O
// module chunks = 75